var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{staticClass:"error",attrs:{"show":"","variant":"danger"}},[(_vm.email)?_c('span',[_vm._v(_vm._s(_vm.$t('email')))]):_vm._e(),(_vm.cpf)?_c('span',[_vm._v(_vm._s(_vm.$t('cpf')))]):_vm._e(),(_vm.somethingWrong)?_c('span',[_vm._v(_vm._s(_vm.$t('somethingWentWrong')))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }